import React from 'react'
import Logo from '../../components/Logo'
import PageFooter from '../Footer'
import img1 from './01.png'
import img2 from './02.png'
import './index.css'

const Home = ({go}) => {
  return (
    <div>
      <div className='ddp-hop'>
        <div className='hop-ti'>
          <div className='hop-ti-con'>
            <div className='hop-ti-he'>
              <div className='hop-ti-lo'>
                <Logo classNames='_he-5' />
              </div>
              <h1><span className='c-he'>Dadopa</span> Databáze dotčených parcel</h1>
            </div>
            <p>Pro stavební projektanty a všechny, kdo pracují s informacemi o&nbsp;parcelách. Jednoduše načtete informace z KÚ, přidáte vlastní údaje, popisy a komentáře, informace uspořádáte a seřadíte... Šetříte čas a&nbsp;máte přehled!</p>
            <button onClick={() => go('/try')} className='but-hig but-hig-b noa'>Vyzkoušet</button>
          </div>
        </div>
        <div className='hop-ti _ti-vi'>
          <img src={img1} alt="Načítání z KN" />
        </div>
        <div className='hop-ti _ti-vi'>
          <img src={img2} alt="Správce" />
        </div>
        <div className='hop-ti'>
          <div className='hop-ti-con'>
            <ul>
              <li>Načítání z Nahlížení do KN</li>
              <li>Vlastní sestavy</li>
              <li>Řazení podle čísla parcely nebo podle vlastníka</li>
              <li>Plochy dotčení, záborů, výkupu</li>
              <li>Poznámky (kontakty, stav projednávání...)</li>
              <li>Uživatelské štítky</li>
              <li>Filtrování</li>
              <li>Hromadné úpravy</li>
              <li>Oceňování</li>
              <li>Export a import</li>
            </ul>
            <a className='but-hig but-hig-b a-hig' href='https://jesyka.cz/dadopa-pruvodce-uzivatele/'>Zjistit více</a>
          </div>
        </div>
      </div>
      <PageFooter />
    </div>
  )
}

export default Home



// WEBPACK FOOTER //
// ./src/pages/Home/indexC.js